import React from 'react';
// import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import styled from 'styled-components';
// import { getDisplayName } from 'recompose';
import { colorForTeam } from '../../../../helpers/TeamColorProfile';

const PlayerShirtNumber = styled.span`
    position: absolute;
    top: 22%;
    left: 50%;
    line-height: 1;
    font-family: ${props => props.theme.shirtNumbersFontFamily}, sans-serif;
    font-style: normal;
    z-index: 1;
    color: ${props => (props.is3d ? colorForTeam(props.teamId, props.isGK ? 'gkShirtNumber' : 'shirtNumber') : '#fff')};
    text-shadow: ${props => (props.is3d ? '' : '0px 0px 1px black')};
    transform: translate(-50%, 0%);
    font-size: ${props => props.size * 0.53125 || 18}px;
    ${props => props.smallNumber && `font-size: 18px;`};
    font-weight: normal;
`;

const NameOnShirt = styled.span`
    position: absolute;
    top: 16%;
    left: 20%;
    right: 20%;
    line-height: 1;
    font-family: ${props => props.theme.shirtNumbersFontFamily}, sans-serif;
    font-style: normal;

    z-index: 1;
    color: ${props => (props.is3d ? colorForTeam(props.teamId, props.isGK ? 'gkShirtNumber' : 'shirtNumber') : '#fff')};
    text-shadow: ${props => (props.is3d ? '' : '0px 0px 1px black')};
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${props => (props.size / 300) * 28}px;
    line-height: 1em;
    text-align: center;
    font-weight: normal;
`;

const PL = styled.span`
    ${({ resetImageWrapStyle }) => (!resetImageWrapStyle ? 'position: relative; display: inline-block;' : '')};

    ${({ cropLogo, height }) =>
        cropLogo
            ? `
        > span:nth-child(1) {
             display: inline-block;
             height: ${height}px;
             max-width: ${height}px;
             overflow: hidden;

             .wdp-sm-plr-logo_image {
                height: calc(${height}px + 40px);
                margin-left: 50%;
                transform: translateX(-50%);
             }
        }
    `
            : ''};
`;

class PlayerLogo extends React.Component {
    static defaultProps = {
        size: 'medium',
        jerseys: false,

        displayTypes: ['none', 'image', 'jersey'],
    };

    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        plrLogoSettings: PropTypes.object,
    };

    getPlrLogoSrc(playerId, teamId, seasonId, size, isGK, isCoach) {
        switch (this.getDisplayType()) {
            case '3d_jersey_back':
            case '3d_jersey_front':
                return isCoach
                    ? 'https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts/coach.svg'
                    : `https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts/ic_${
                          isGK ? 'gk_' : ''
                      }shirt_${teamId}.svg`;
            case 'jersey':
                return this.showClubsJerseys(playerId, teamId, size, isGK);
            case 'image':
                return this.getPlrImageSrc(playerId, teamId, seasonId, size);
            default:
                return this.showClubsJerseys(playerId, teamId, size, isGK);
        }
    }

    getPlrImageSrc = (playerId, teamId, seasonId, size) => {
        const client = this.context && this.context.info && this.context.info.client;
        let url;

        switch (size) {
            case 'big':
                url = RCore.imageUrls.getPlayerImgBig(teamId, playerId, seasonId);
                break;
            case 'large':
                url = RCore.imageUrls.getPlayerLargeImg(teamId, playerId, seasonId);
                break;
            case 'original':
                url = RCore.imageUrls.getPlayerImgOriginal(teamId, playerId, seasonId);
                break;
            default:
                url = RCore.imageUrls.getPlayerImg(teamId, playerId, seasonId);
                break;
        }
        // make bucket support
        if (client === 'spdk') {
            url = url.replace(/\/wdp\//, '/spdk/');
        }

        return url;
    };

    showClubsJerseys = (playerId, teamId) => {
        const width = 120;
        const height = 120;
        return `https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_${teamId}.png&width-px=${width}&height-px=${height}&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png`;
    };

    getDisplayType() {
        const { seasonId } = this.props;
        //If we do not have players images on CDN, show jersey
        // fallback if there is no player images

        if (
            this.props.display === 'image' &&
            !RCore.hasCDNPlayerLogos(seasonId, this.context.info && this.context.info.client)
        ) {
            return '3d_jersey_front';
        }

        return this.props.display || 'jersey';
    }

    render() {
        let {
            playerId,
            teamId,
            seasonId,
            // name,
            // isNational,
            isGK,
            isCoach,
            size,
            height,
            width,
            // display,
            spdk,
            number = null,
            positionEnetType,
            resetImageWrapStyle = false,
            imageWrapStyle = {},
            style = {},
            nameOnShirt,
            rounded,
            cropLogo,
            nameOnShirt3dJerseySize,
            // ...rest
        } = this.props;

        // var screenSize = this.context.screenSizeObserver.screenSize
        if (this.context.plrLogoSettings && this.context.plrLogoSettings.display === 'none')
            return <span className="wdp-sm-plr-logo__none" />;
        const imageClasses = cx(
            'wdp-sm-plr-logo',
            'wdp-sm-plr-logo_' + this.getDisplayType(),
            'wdp-sm-plr-logo_' + size,
        );

        const stylesString = RCore.stylesObjectToString({
            objectFit: !rounded ? 'contain' : 'cover',
            marginBottom: spdk ? '-38%' : '0',
            ...style,
        });

        isGK = isGK || positionEnetType === 1;
        const displayType = this.getDisplayType();
        const showNumber = ['3d_jersey_front', '3d_jersey_back', 'jersey'].includes(displayType);
        const smallNumber = displayType === 'jersey';
        const is3d = ['3d_jersey_front', '3d_jersey_back'].includes(displayType);

        // for rounded img
        const roundedImgSize = width || height;
        width = !rounded ? width : roundedImgSize;

        const imageRoundStyles = rounded
            ? {
                  minWidth: `${roundedImgSize}px`,
                  maxWidth: `${roundedImgSize}px`,
                  height: `${roundedImgSize}px`,
                  overflow: 'hidden',
                  borderRadius: '50%',
              }
            : {};

        const imageSpdkFaceSpan = spdk
            ? {
                  display: 'inline-block',
                  overflow: 'hidden',
              }
            : {};

        return (
            <PL
                className={[this.props.className, displayType].join(' ')}
                is3d={is3d}
                style={{ ...imageWrapStyle, ...imageRoundStyles }}
                resetImageWrapStyle={resetImageWrapStyle}
                cropLogo={cropLogo}
                height={height}
            >
                <span
                    style={{ ...imageSpdkFaceSpan }}
                    dangerouslySetInnerHTML={{
                        __html: `<img style="${stylesString}" width="${width || 'auto'}" height="${height ||
                            'auto'}" class="${imageClasses} ${spdk ? 'wdp-sm-plr-logo-spdk' : ' '} ${
                            rounded ? 'wdp-sm-plr-logo-rounded' : ' '
                        }" onerror="this.onerror=null;this.src = 'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_shirt_unknown.svg'" src='${this.getPlrLogoSrc(
                            playerId,
                            teamId,
                            seasonId,
                            size,
                            isGK,
                            isCoach,
                        )}?a=2' draggable='false'/>`,
                    }}
                />

                <PlayerShirtNumber
                    className="player-shirt-number"
                    is3d={is3d}
                    size={
                        nameOnShirt3dJerseySize ||
                        _.chain([+height, +width])
                            .compact()
                            .first()
                            .value()
                    }
                    isGK={isGK}
                    teamId={teamId}
                    smallNumber={smallNumber}
                >
                    {showNumber && number}
                </PlayerShirtNumber>
                {is3d &&
                    nameOnShirt && (
                        <NameOnShirt
                            className="mame-on-shirt-number"
                            is3d
                            size={
                                nameOnShirt3dJerseySize ||
                                _.chain([+height, +width])
                                    .compact()
                                    .first()
                                    .value()
                            }
                            isGK={isGK}
                            teamId={teamId}
                            smallNumber={smallNumber}
                        >
                            {nameOnShirt}
                        </NameOnShirt>
                    )}
            </PL>
        );
    }
}
PlayerLogo.spec = {
    propType: {
        key: 'plrImage',
        type: 'select_picker',
        label: 'Player image',
        options: [
            {
                text: 'None',
                value: 'none',
            },
            {
                text: 'Jersey',
                value: 'jersey',
            },
            {
                text: 'Image',
                value: 'image',
            },
        ],
    },
};

const PlayerLogo3DJerseyBack = props => {
    return <PlayerLogo {...props} display="3d_jersey_back" />;
};
const PlayerLogo3DJerseyFront = props => {
    return <PlayerLogo {...props} display="3d_jersey_front" />;
};
const PlayerLogoJersey = props => {
    return <PlayerLogo {...props} display="jersey" />;
};
const PlayerLogoPhoto = props => {
    return <PlayerLogo {...props} display="image" />;
};
const PlayerLogoSPDKFace = props => {
    return <PlayerLogo {...props} display="image" spdk />;
};
const PlayerRoundedPhoto = props => {
    return <PlayerLogo {...props} display="image" rounded />;
};

export default PlayerLogo;
export {
    PlayerLogo3DJerseyBack,
    PlayerLogo3DJerseyFront,
    PlayerLogoJersey,
    PlayerLogoPhoto,
    PlayerLogoSPDKFace,
    PlayerRoundedPhoto,
};



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/playerLogo/SMPlayerLogo.js
 **/